import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api, categoryName } from "@/lib/api";
import { ProductCard } from "@/components/ProductCard";
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from "@/components/ui/select";

export default function Shop() {
  const { slug } = useParams();
  const [products, setProducts] = useState([]);
  const [sort, setSort] = useState("new");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    const params = {};
    if (slug) params.category = slug;
    if (sort !== "new") params.sort = sort;
    api.get("/products", { params }).then((r) => {
      setProducts(r.data);
      setLoading(false);
    });
  }, [slug, sort]);

  const title = slug ? categoryName(slug) : "All Products";

  return (
    <div className="mx-auto max-w-7xl px-4 py-12 md:px-8">
      <div className="mb-8 flex flex-col gap-4 border-b border-zinc-200 pb-6 sm:flex-row sm:items-end sm:justify-between">
        <div>
          <p className="label-eyebrow">Collection</p>
          <h1 className="font-display mt-2 text-3xl font-light tracking-tight md:text-4xl" data-testid="shop-title">
            {title}
          </h1>
          <p className="mt-2 text-sm text-zinc-500">{products.length} products</p>
        </div>
        <Select value={sort} onValueChange={setSort}>
          <SelectTrigger className="w-48 rounded-none border-zinc-300" data-testid="sort-select">
            <SelectValue placeholder="Sort" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="new">Newest</SelectItem>
            <SelectItem value="price_asc">Price: Low to High</SelectItem>
            <SelectItem value="price_desc">Price: High to Low</SelectItem>
          </SelectContent>
        </Select>
      </div>

      {loading ? (
        <div className="py-24 text-center text-sm text-zinc-400">Loading…</div>
      ) : products.length === 0 ? (
        <div className="py-24 text-center text-sm text-zinc-500">No products in this category yet.</div>
      ) : (
        <div className="grid grid-cols-2 gap-x-6 gap-y-12 md:grid-cols-3 lg:grid-cols-4">
          {products.map((p) => (
            <ProductCard key={p.id} product={p} />
          ))}
        </div>
      )}
    </div>
  );
}
